module.exports = __webpack_public_path__ + "static/name-scribble-494e6815761c705da53b7519084e69d7.svg";